import React from "react";
import CreatEditAccountContainer from "../../../containers/Account/CreateEditAccount";

const CreateEditAccountScreen = () => {
  return <CreatEditAccountContainer />;
};

export default CreateEditAccountScreen;
